import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { Box, Badge, IconButton, useMediaQuery } from "@mui/material";
import request from "../utilities/requests";
import { EventContext } from "../contexts/EventContext";
import { toast } from "../utilities/SnackBarUtils";

const MessagingIcon = ({ color }) => {
  const navigate = useNavigate();
  const { socket, messageCount, setMessageCount } = useContext(EventContext);
  const isDesktop = useMediaQuery("(min-width:600px)");
  const [pulse, setPulse] = useState(false);

  // Placeholder: call server to get unread count
  const fetchUnreadCount = async () => {
    try {
      const result = await request("messaging/unread");
      if (result.success) {
        setMessageCount(result.count);
      }
    } catch (error) {
      console.log("Error fetching unread count", error);
    }
  };

  const handleConnectError = (err) => {
    // Silent self-heal: refresh token from localStorage and reconnect
    console.warn("[socket connect_error] attempting silent token refresh");
    try {
      const newToken = localStorage.getItem(
        `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`
      );
      if (newToken) {
        socket.auth = { ...(socket.auth || {}), token: newToken };
        if (socket.connected) {
          socket.disconnect().connect();
        } else {
          socket.connect();
        }
      } else {
        // No token available; optional: keep a single console for debugging
        console.error(
          "[socket] no access token in localStorage; cannot refresh auth"
        );
      }
    } catch (e) {
      console.error("[socket] token refresh failed", e);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
  }, []);

  useEffect(() => {
    if (!socket) return;

    const onConnectError = (err) => {
      console.warn("[socket connect_error] attempting silent token refresh");

      try {
        const newToken = localStorage.getItem(
          `${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`
        );
        if (newToken) {
          socket.auth = { ...(socket.auth || {}), token: newToken };
          socket.disconnect().connect();
        }
      } catch (e) {
        console.error("[socket] token refresh failed", e);
      }
    };

    const onNewSMS = async () => {
      await fetchUnreadCount();
      setPulse(true);
      setTimeout(() => setPulse(false), 500);
      toast.success("New message received!");
    };

    socket.on("connect_error", onConnectError);
    socket.on("new_sms", onNewSMS);

    if (!socket.connected) {
      socket.connect();
    }

    return () => {
      socket.off("connect_error", onConnectError);
      socket.off("new_sms", onNewSMS);
    };
  }, [socket]);

  const handleClick = () => {
    navigate("/messaging");
  };

  const style = isDesktop
    ? {
        position: "fixed",
        top: 16,
        right: 48,
        // zIndex: 999999,
      }
    : {
        position: "static",
      };

  return (
    <Box id="messaging-bell-icon" sx={style}>
      <IconButton onClick={handleClick}>
        <Badge
          badgeContent={Number(messageCount) || 0}
          color="error"
          sx={{
            "& .MuiBadge-badge": {
              animation: pulse ? "pulse 1s ease-in-out" : "none",
              backgroundColor: isDesktop ? undefined : "#fff",
              color: isDesktop ? undefined : "#000",
            },
            "@keyframes pulse": {
              "0%": { transform: "scale(1)" },
              "50%": { transform: "scale(2.3)" },
              "100%": { transform: "scale(1)" },
            },
          }}
        >
          <ChatBubbleOutlineIcon style={{ color }} />
        </Badge>
      </IconButton>
    </Box>
  );
};

export default MessagingIcon;
